export default "__VITE_ASSET__DaEIGReT__"